import { Component, Input, OnChanges, SimpleChanges, OnInit, Output, EventEmitter } from '@angular/core';
import { MenuItem } from '@models/global';
import { Product } from '@models/product';
import { RouteService } from '@services/route.service';
import { ProductService } from '@services/product.service';
import { ProductFilter } from 'src/app/models/filter';
import { forkJoin } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface MenuColumn {
  type: 'list' | 'visual-stack' | 'visual-grid' | 'multi-list';
  title: string;
  titleColor: 'green' | 'orange';
  items: any[];
  className?: string; // Pour appliquer square-visuals uniquement si besoin
}

@Component({
  selector: 'gob-global-menu',
  templateUrl: './global-menu.component.html',
  styleUrls: ['./global-menu.component.scss']
})
export class GlobalMenuComponent implements OnInit, OnChanges {

  @Input() parentItem: MenuItem | undefined;
  @Output() clicked = new EventEmitter<void>();

  menuWidth: string = '800px';
  columns: MenuColumn[] = [];
  visualsSociete: any[] = [];
  imageErrors: { [key: number]: boolean } = {};

  usedIdent = environment.menuIdents.used;
  crushIdent = environment.menuIdents.crush;
  promosIdent = environment.menuIdents.promos;
  newsIdentr = environment.menuIdents.news;
  preOrderIdent = environment.menuIdents.preorder;

  // --- DONNÉES STATIQUES (REMISES À L'ORIGINE) ---
  private dataJdc = [
    { label: 'Magic', img: 'assets/img/logos/magic.png', lien: ['/products/scateg/68394191d7ce3/magic'] },
    { label: 'Pokémon', img: 'assets/img/logos/pokemon.png', lien: ['/products/scateg/68394191d70f0/Pokémon'] },
    { label: 'Yu-Gi-Oh!', img: 'assets/img/logos/yugioh.png', lien: ['/products/scateg/68394191d77b2/Yu-Gi-Oh'] },
    { label: 'Riftbound', img: 'assets/img/logos/riftbound.png', lien: ['/products/scateg/6985cf8552aa3/riftbound'] },
    { label: 'Star Wars', img: 'assets/img/logos/starwars.png', lien: ['/products/scateg/68394191d7aba/Star Wars'] },
    { label: 'Lorcana', img: 'assets/img/logos/lorcana.png', lien: ['/products/scateg/68394193737b7/Lorcana'] }
  ];

  private dataFigurines = [
    { label: 'Warhammer 40,000', img: 'assets/img/top-figurines/warhammer.jpg', lien: ['/products/scateg/683941920716b/Warhammer 40000'] },
    { label: 'Star Wars Legion', img: 'assets/img/top-figurines/star-wars.jpg', lien: ['/products/scateg/683941920a40e/Star wars - légion'] },
    { label: 'Peintures & Accessoires', img: 'assets/img/top-figurines/accessoires.jpg', lien: ['/products/scateg/68394191d0c26/peintures-et-accessoires'] }
  ];

  private dataJdr = [
    { label: 'Dungeons & Dragons', img: 'assets/img/menu-jdr/d&d.png', lien: ['/products/scateg/68394191f1c86/donjons-dragons'] },
    { label: 'L\'Appel de Cthulhu', img: 'assets/img/menu-jdr/cthulhu.png', lien: ['/products/scateg/68394191db3e4/appel-de-cthulhu'] },
    { label: 'L\'Anneau Unique', img: 'assets/img/menu-jdr/anneauunique.png', lien: ['/products/scateg/68394191da299/anneau-unique'] }
  ];

  private dataShops = [
    { label: 'Nancy', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/nancy' },
    { label: 'Metz', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/metz' },
    { label: 'Thionville', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/thionville' },
    { label: 'Pont-à-Mousson', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/pont-a-mousson' },
    { label: 'Semécourt', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/semecourt-semecourt' },
    { label: 'Toul', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/toul' }
  ];

  private dataTournaments = [
    { label: 'Yu-Gi-Oh!', lien: 'https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/yu-gi-ho' },
    { label: 'Magic', lien: 'https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/magic' },
    { label: 'Pokémon', lien: 'https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/pokemon' },
    { label: 'RiftBound', lien: 'https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/riftbound' },
    { label: 'Lorcana', lien: 'https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/lorcana' },
    { label: 'Autres Tournois', lien: 'https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/toutes' }
  ];

  private dataActivities = [
    { label: 'Jeux de société', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe' },
    { label: 'Jeux de rôles', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-role' },
    { label: 'Cartes à collectionner', lien: 'https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner' },
    { label: 'Figurines', lien: 'https://lesanimationsdugobelin.com/animations/evenements/figurines' }
  ];

  constructor(
    private pServ: ProductService,
    private route: RouteService
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.parentItem) {
      this.buildMenu();
    }
  }

  private buildMenu() {
    this.columns = [];
    if (!this.parentItem) return;

    const name = this.normalize(this.parentItem.name);
    const children = this.parentItem.children || [];

    if (name.includes('societe')) {
      this.configureSociete(children);
    } else if (name.includes('cartes')) {
      this.configureCartes(children);
    } else if (name.includes('figurines')) {
      this.configureFigurines(children);
    } else if (name.includes('role')) {
      this.configureRole(children);
    } else if (name.includes('accessoires')) {
      this.configureAccessoires(children);
    } else if (name.includes('animation')) {
      this.configureAnimations();
    } else {
      this.menuWidth = '300px';
      this.columns.push({
        type: 'list',
        title: this.parentItem.name,
        titleColor: 'green',
        items: this.mapChildrenToItems(children)
      });
    }
  }

  private configureAnimations() {
    this.menuWidth = '700px';
    this.columns.push({ type: 'list', title: 'Nos cafés-jeux', titleColor: 'green', items: this.dataShops });
    this.columns.push({ type: 'list', title: 'Nos tournois JCC', titleColor: 'green', items: this.dataTournaments });
    this.columns.push({ type: 'list', title: 'Nos activités', titleColor: 'green', items: this.dataActivities });
  }

  private configureSociete(children: MenuItem[]) {
    this.menuWidth = '950px';
    this.getRandomProductsForCategory('societe');

    this.columns.push({
      type: 'visual-stack',
      title: 'À la une',
      titleColor: 'orange',
      items: this.visualsSociete,
      className: 'square-visuals' // Application de la classe spécifique demandée
    });

    const mid = Math.ceil(children.length / 2);
    this.columns.push({ type: 'multi-list', title: '', titleColor: 'green', items: this.mapCategoriesWithChildren(children.slice(0, mid)) });
    this.columns.push({ type: 'multi-list', title: '', titleColor: 'green', items: this.mapCategoriesWithChildren(children.slice(mid)) });
  }

  private configureCartes(children: MenuItem[]) {
    this.menuWidth = '900px';
    this.columns.push({ type: 'visual-grid', title: 'Les + Populaires', titleColor: 'orange', items: this.dataJdc });
    const autres = children.find(c => this.normalize(c.name).includes('autres'))?.children || [];
    this.columns.push({ type: 'list', title: 'Autres jeux', titleColor: 'green', items: this.mapChildrenToItems(autres) });
    const evol = children.find(c => this.normalize(c.name).includes('evolutif'))?.children || [];
    this.columns.push({ type: 'list', title: 'Jeux évolutifs', titleColor: 'green', items: this.mapChildrenToItems(evol) });
  }

  private configureFigurines(children: MenuItem[]) {
    this.menuWidth = '750px';
    this.columns.push({ type: 'visual-stack', title: 'Les + Populaires', titleColor: 'orange', items: this.dataFigurines });
    const autres = children.find(c => this.normalize(c.name).includes('autres'))?.children || [];
    this.columns.push({ type: 'list', title: 'Autres jeux', titleColor: 'green', items: this.mapChildrenToItems(autres) });
  }

  private configureRole(children: MenuItem[]) {
    this.menuWidth = '750px';
    this.columns.push({ type: 'visual-stack', title: 'Les + Populaires', titleColor: 'orange', items: this.dataJdr });
    const autres = children.find(c => this.normalize(c.name).includes('autres'))?.children || [];
    this.columns.push({ type: 'list', title: 'Autres jeux', titleColor: 'green', items: this.mapChildrenToItems(autres) });
  }

  private configureAccessoires(children: MenuItem[]) {
    this.menuWidth = '600px'; // On réduit la largeur totale car on passe sur 2 colonnes internes
    const keys = ['cartes', 'societe', 'figurines', 'role'];
    const items: any[] = [];

    keys.forEach(key => {
      const found = children.find(c => this.normalize(c.name).includes(key));
      if (found) {
        items.push({
          label: found.name,
          lien: this.getLink(found),
          subItems: this.mapChildrenToItems(found.children || [])
        });
      }
    });

    this.columns.push({
      type: 'multi-list',
      title: '',
      titleColor: 'green',
      items: items,
      className: 'grid-accessoires'
    });
  }

  isExternalLink(lien: any): boolean {
    return typeof lien === 'string' && lien.startsWith('http');
  }

  onImageError(productId: number): void {
    this.imageErrors[productId] = true;
  }

  private getRandomProductsForCategory(category: string): void {
    if (category !== 'societe') return;
    this.visualsSociete = [];
    const crushFilter = new ProductFilter(); crushFilter.banner = this.crushIdent;
    const preorderFilter = new ProductFilter(); preorderFilter.banner = this.preOrderIdent;
    const usedFilter = new ProductFilter(); usedFilter.gamme = this.usedIdent;

    forkJoin({
      crush: this.pServ.searchProducts(crushFilter, 0, 1),
      preorder: this.pServ.searchProducts(preorderFilter, 0, 1),
      used: this.pServ.searchProducts(usedFilter, 0, 1)
    }).subscribe({
      next: ({ crush, preorder, used }) => {
        const pushItem = (products: Product[], label: string, customLink: string[]) => {
          const formatted = this.formatForHtml(products);
          formatted.forEach(p => {
            this.visualsSociete.push({ ...p, label: label, lien: customLink});
          });
        };
        pushItem(crush, 'Coups de coeur', ['/products', 'banner', this.crushIdent, 'coups-de-coeur']);
        pushItem(preorder, 'Précommandes', ['/products', 'banner', this.preOrderIdent, 'precommandes']);
        pushItem(used, "Occasions", ['/products', 'gamme', this.usedIdent, 'jeux-d-occasion']);

      }
    });
  }

  private formatForHtml(products: Product[]): any[] {
    return products.map(p => {
      let img = p.mainImage ? p.mainImage.name : (p.images && p.images.length > 0 ? p.images[0].name : `assets/img/logo/logo.png`);
      let imgPath = `${environment.imgUrl}/product/${img}`;
      return { label: p.name, img: imgPath, lien: ['/product', p.ident] };
    });
  }

  private normalize(str: string): string {
    return str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  private mapChildrenToItems(children: MenuItem[]): any[] {
    return children.map(child => ({ label: child.name, lien: this.getLink(child) }));
  }

  private mapCategoriesWithChildren(categories: MenuItem[]): any[] {
    return categories.map(cat => ({
      label: cat.name,
      lien: this.getLink(cat),
      subItems: this.mapChildrenToItems(cat.children || [])
    }));
  }

  private getLink(item: MenuItem): any {
    let name = this.normalize(item.name).trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return this.route.parse('products-list', [item.type, item.val, name]);
  }

  onItemClick(): void {
    this.clicked.emit();
  }
}
